import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"

import Filter from "./mobile/filter"
import Backdrop from "../../../Backdrop"
import useVariable from "../../../../hook/useVariable"
import { Link } from "react-router-dom"
import InfoIcon from "../../../InfoIcon"
import { faCircleArrowDown, faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons"

export default function MobileComponent() {

    return <div>MobileComponent</div>

    const [orders, setOrders] = useState()

    const [mobileItems, setMobileItems] = useState()


    let filteredOrders = useSelector((state) => state.order.filteredOrders)

    let dispatch = useDispatch()

    let selectedorders = useSelector(state => state.order.selectedOrders)

    let stateorders = useSelector(state => state.order.orders)


    useEffect(() => {

        let items = []
        let orders = filteredOrders ?? stateorders

        if (orders && Object.keys(orders).length > 0) {

            orders.forEach((order) => {

                items.push(<MobileItem key={order.id} order={order} />)

            })
        }
        setMobileItems(items)



    }, [filteredOrders, stateorders])


    if (!mobileItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            {mobileItems}
        </Filter>
        <Backdrop />
    </Fragment>
}


function MobileItem(props) {
    const { order } = props

    const [showContent, setShowContent] = useState(false)


    return <Fragment>

            <div className="card shadow  bg-white rounded p-3" style={{ cursor: 'pointer' }} onClick={() => {
                setShowContent(!showContent)
            }}  >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }} >
                    <span>{order.order_id}</span>
                    <span>{order.ptitle}</span>
                    <span>{order.start}</span>
                </div>
                <InfoIcon icon={faCircleArrowDown} size='xl' />

            </div>
            {showContent &&
                <table className="table table-striped table-bordered" >
                    <tbody>
                        <tr>
                            <th>OrderId</th>
                            <td>
                                {order.order_id}
                            </td>
                        </tr>
                        <tr>
                            <th>ProductTitle</th>

                            <td>
                            <Link to={`/products/${order.product_id}`} >{order.title}</Link>
                            </td>
                        </tr>
                        <tr>
                            <th>Active</th>
                            <td>
                                {order.active ? 'true' : 'false'}
                            </td>
                        </tr>
                        <tr>
                            <th>Start</th>
                            <td>
                                {order.start}
                            </td>
                        </tr>
                      <tr>
                      <th>End</th>
                        <td>
                            {order.end}
                        </td>
                      </tr>
                        <tr>
                            
                            <th>Edit</th>
                            <td>
                                <Link className="btn btn-outline-secondary bgnt" to={`/orders/${order.id}`} ><InfoIcon icon={faInfoCircle} title='order details' /></Link>
                            </td>

                        </tr>

                    </tbody>
                </table>
            }


    </Fragment>

}